export default "__VITE_ASSET__298df79a__"